<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title class="d-flex align-center">
        <span
          class="font-weight-bold"
          v-text="label"
        />
        <span class="pr-1">:</span>
        <span
          class="word-break"
          :style="look"
          v-text="content"
        />
        <span class="pl-1">
          <slot />
        </span>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'BaseListItem',
  props: {
    label: {
      type: String,
      required: true,
      note: 'The item label',
    },
    content: {
      type: [String, Number, Object],
      required: true,
      note: 'The item content',
    },
    look: {
      type: String,
      default: '',
      note: 'The datum custom style',
    },
  },
};
</script>

<style scoped>
.word-break {
  white-space: normal;
  word-break: break-all;
}
</style>
